import { useState, useContext } from "react";
import { registerUser } from "../api/authService"; // Assuming you have a similar function like loginUser for registration
//import './Register.css'; // Optional, for specific styles
import { BarbershopContext } from "../providers/useProvider";
import { useNavigate, useParams } from "react-router-dom"; // For navigating after login

const useRegister = () => {
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState(null);
  const [showMessage, setShowMessage] = useState(false);

  const { config } = useContext(BarbershopContext);
  const navigate = useNavigate();

  return {
    register: async (userData, barbershop) => {
      var user = {
        ShopId: config.id,
        IsCustomer: true,
        Barbershop: barbershop,
        FirstName: userData.firstName,
        LastName: userData.lastName,
        PhoneNumber: userData.phoneNumber,
        Country: userData.country,
        CountryCode: userData.countryCode,
        Email: userData.email,
        Password: userData.password,
        ConfirmPassword: userData.confirmPassword,
      };
      setLoading(true);
      setMessage(null);
      setShowMessage(false);
      try {
        const response = await registerUser(user);
        if (response.isSuccess) {
          setMessage({ text: response.value, type: "success" });
          setShowMessage(true);
          // Wait 4 seconds, then call run
          setTimeout(() => navigate(`/login`), 4000);
        } else {
          setMessage({ text: response.errors.join("\n"), type: "danger" });
          setShowMessage(true);
        }
      } catch (err) {
        setMessage({
          text: err.response?.data?.message || "Registration failed",
          type: "danger",
        });
        setShowMessage(true);
        return null;
      } finally {
        setLoading(false);
      }
    },
    loading,
    message,
    setShowMessage,
    showMessage,
  };
};
export default useRegister;
